import { MessageMedium } from 'modules/domains/campaign';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { NBABadge } from '../NBABadge';
import { RecommendedContentDropdown } from '../recommendedContents/RecommendedContentDropdown';
import { RecommendedReadOnlyContent } from '../recommendedContents/RecommendedReadOnlyContent';
import { Recommendations, StyledNBASuggestionCard } from './SuggestionCard.styles';

// for testing
const suggestions = [
  {
    suggestionText: 'Need to cool off? Swing by and beat the heat with our sweet, icy treats!',
    moodText: 'Cheerful with a hint of suggestion',
  },
  {
    suggestionText:
      "We'll help you beat the heat, one scoop at a time. Swing by after work and cool down with our delicious treats! See you soon!",
    moodText: 'Friendly and inviting with a call to action',
  },
  {
    suggestionText: 'You deserve something special. Swing by for a sweet treat!',
    moodText: 'Upbeat, positive, and persuasive',
  },
];

export const NBA_SUGGESTION_CARD_ID = 'nba-suggestion-card';

export type SuggestionCardProps = {
  messageMedium: MessageMedium;
  onSetSuggestion?: (suggestion: string) => void;
  onPreviewClick: () => void;
  selectedSuggestion: string;
};

export const SuggestionCard = ({
  selectedSuggestion,
  onSetSuggestion,
  onPreviewClick,
  messageMedium,
  ...props
}: SuggestionCardProps) => {
  return (
    <StyledNBASuggestionCard data-test={NBA_SUGGESTION_CARD_ID} {...props}>
      <NBABadge />
      <Recommendations>
        {onSetSuggestion ? (
          <RecommendedContentDropdown
            isLoading={false}
            messageMedium={messageMedium}
            onSelectValue={onSetSuggestion}
            selectedValue={selectedSuggestion}
            suggestions={suggestions}
          />
        ) : (
          <RecommendedReadOnlyContent
            selectedValue={selectedSuggestion}
            suggestions={suggestions}
          />
        )}
      </Recommendations>
      <Button
        size={BUTTON_SIZES.LARGE}
        variant={BUTTON_VARIANTS.SECONDARY}
        onClick={onPreviewClick}
      >
        Preview suggestion
      </Button>
    </StyledNBASuggestionCard>
  );
};
